// extracted by mini-css-extract-plugin
module.exports = {"root":"CardReaderDesc_root__30CYl","col":"CardReaderDesc_col__2jwOp","label":"CardReaderDesc_label__2oC3r"};